var Vue = require('vue');

let bus = new Vue();

module.exports =  bus;



// WEBPACK FOOTER //
// ./~/vue-pagination-2/src/bus.js